// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../../shared/action-creators/busy-counter';
import OpenMaintenancePlan, {getDefaultState as getOpenMaintenancePlanDefaultState} from '@deere/cps-it.warranty-model-factory/lib/open-maintenance-plan';
import {
    resetConfirmationModal,
    updateConfirmationModal
} from './confirmation-modal';
import actions from '../../../action-list';
import {addAuditVsrToClaim} from '../../../shared/services/claim-vsr-helper';
import {bindActionCreators} from 'redux';
import {canGetMaintenancePlans} from '../services/claim-validation-helper';
import {confirmationModalMap} from '../services/confirmation-modal-map';
import {copyClaim} from './copy-claim';
import {getClaim} from '../../../shared/repositories';
import {readClaimProduct} from './get-product-details';
import {readOpenMaintenancePlans} from './get-open-maintenance-plans';
import {readOpenServiceIntervals} from './get-open-service-intervals';
import {shouldRunAdditionalAction} from '../../../shared/services/claim-shared-helper';
import {updateSelectedAction} from './update-selected-action';

const handleRouteAction = (action, claim, dispatch) => {

    const actionsToBeBound = {
        resetConfirmationModal,
        updateSelectedAction
    };

    const boundActionCreators = bindActionCreators(actionsToBeBound, dispatch);

    const confirmActions = {
        adjust: boundActionCreators.updateSelectedAction.bind(null, action),
        delete: boundActionCreators.updateSelectedAction.bind(null, action),
        pushxml: boundActionCreators.updateSelectedAction.bind(null, action),
        reconcile: boundActionCreators.updateSelectedAction.bind(null, action),
        unreconcile: boundActionCreators.updateSelectedAction.bind(null, action)
    };

    const actionMethod = confirmationModalMap(action, boundActionCreators.resetConfirmationModal, confirmActions);

    const map = {
        COPY_CLAIM: copyClaim,
        DIS_VSR: boundActionCreators.updateSelectedAction.bind(null, action),
        SUB: boundActionCreators.updateSelectedAction.bind(null, action)
    };

    if (['RECONCILE', 'UNRECONCIL', 'DEL', 'REQ_ADDL', 'PUSH_XML'].includes(action.id)) {

        dispatch(updateConfirmationModal(actionMethod));

    } else {

        map[action.id](claim)(dispatch);

    }

};

/* eslint-disable complexity */

export const readClaim = (claimNumber, action) =>

    async (dispatch, getState) => {

        let updatedClaim;

        dispatch(busyCounter.increaseBusyCounter());

        try {

            updatedClaim = await getClaim(claimNumber, 'maintenance-plan-claims');

            // adds special VSR for claim in audit status

            if (updatedClaim.claimStatus.key === 'ZADT') {

                updatedClaim = addAuditVsrToClaim(updatedClaim);

            }

            dispatch({
                type: actions.SET_CLAIM_MAINTENANCE_PLAN,
                updatedClaim
            });

            if (action && shouldRunAdditionalAction(action)) {

                handleRouteAction(action, updatedClaim, dispatch);

            }

            readClaimProduct(updatedClaim.pin)(dispatch, getState);

            if (canGetMaintenancePlans(updatedClaim)) {

                readOpenMaintenancePlans(updatedClaim, true)(dispatch);
                readOpenServiceIntervals(updatedClaim.planName.key, updatedClaim)(dispatch, getState);

            } else {

                const maintenancePlanObject = new OpenMaintenancePlan({
                    ...getOpenMaintenancePlanDefaultState(),
                    planDescription: updatedClaim.planName.value,
                    planName: updatedClaim.planName.key
                });

                dispatch({
                    maintenancePlanObject,
                    type: actions.UPDATE_CLAIM_MAINTENANCE_PLAN_READ_ONLY_SELECTED_OPEN_MAINTENANCE_PLAN
                });

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };

/* eslint-enable complexity */



// WEBPACK FOOTER //
// ./src/claim/marketing/maintenance-plan/action-creators/get-claim.js